import { render, staticRenderFns } from "./CadDadosDespesas.vue?vue&type=template&id=ad1b2404&"
import script from "./CadDadosDespesas.vue?vue&type=script&lang=js&"
export * from "./CadDadosDespesas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports